<div class="machine-list-container">
  <div class="header-section">
    <h1>Machine List</h1>
  </div>

  <div class="search-section">
    <p-iconfield iconPosition="left">
      <p-inputicon>
        <i class="pi pi-search"></i>
      </p-inputicon>
      <input 
        type="text" 
        pInputText 
        placeholder="Search machines (press Enter)..." 
        (keydown.enter)="onSearch(searchFilter)"
        [(ngModel)]="searchFilter"
        [disabled]="loading"
        class="search-input" />
    </p-iconfield>
  </div>

  <div class="table-section">
    <app-besharp-table
      [tableItems]="machines"
      [loading]="loading"
      [tableDefinitions]="tableDefinitions"
      [actionDefinitions]="getFilteredActions()"
      [actionTitle]="'Actions'"
      [actionLabel]="'Machine Actions'"
      [defaultActive]="'id'"
      [defaultDirection]="-1"
      [idColumnDef]="'id'"
      [paginator]="false"
      [showGridLines]="true"
      [showStripes]="true"
      [rowOverEffect]="true"
      [showCurrentPageReport]="false"
      [showClearFiltersButton]="false"
      (rowClicked)="onRowClicked($event)">
    </app-besharp-table>

    <div class="custom-pagination" style="display: flex; justify-content: space-between; align-items: center; padding: 1rem;">
      <div class="page-info" style="color: #64748B">
        Page {{ currentPage + 1 }}
      </div>
      
      <div class="page-controls" style="display: flex; gap: 0.5rem;">
        <button 
          pButton 
          type="button" 
          icon="pi pi-angle-left" 
          label="Prev"
          [disabled]="currentPage === 0 || loading"
          (click)="goToPreviousPage()"
          style="width: 100px"
          class="p-button-outlined">
        </button>
        
        <button 
          pButton 
          type="button" 
          icon="pi pi-angle-right" 
          iconPos="right"
          label="Next"
          [disabled]="!hasNextPage || loading"
          (click)="goToNextPage()"
          style="width: 100px"
          class="p-button-outlined">
        </button>
      </div>
      
      <div class="page-size-selector" style="display: flex; align-items: center; gap: 0.5rem;">
        <label for="pageSize" style="color: #64748B; font-size: 0.875rem;">Items:</label>
        <select 
          id="pageSize" 
          [(ngModel)]="pageSize" 
          (ngModelChange)="onPageSizeChange()"
          class="p-inputtext p-component"
          style="padding: 0.5rem 0.75rem; font-size: 0.875rem; border: 1px solid #d1d5db; border-radius: 6px; cursor: pointer;">
          <option [value]="10">10</option>
          <option [value]="20">20</option>
          <option [value]="50">50</option>
          <option [value]="5000">5000</option>
        </select>
      </div>
    </div>
  </div>
</div>
<p-toast position="bottom-center"></p-toast>
